/**
 * Judge.me widget copy → Latvian
 *
 * Preferred fix: Judge.me Admin → Settings → Language →
 * "Widget and notification emails language" = Latvian
 * (and optionally customize strings under Settings → Widgets).
 *
 * This theme override is a fallback because the admin language
 * cannot be changed from the theme, and English still ships when
 * the Judge.me account language is left on English.
 */
(function () {
  if ((document.documentElement.lang || '').toLowerCase().indexOf('en') === 0) return;
  const SCOPE =
    '.jdgm-widget, .jdgm-rev-widg, .jdgm-all-reviews-widget, .jdgm-all-reviews-widget-v2025, .jdgm-carousel-wrapper, .jdgm-write-rev-link, .jdgm-write-review-modal, .jdgm-form, [class*="jdgm-"], #judgeme_product_reviews';

  // Longer / more specific phrases first.
  const REPLACEMENTS = [
    [/Be the first to write a review/gi, 'Esiet pirmais, kas raksta atsauksmi'],
    [/No reviews yet,? write one!?/gi, 'Vēl nav atsauksmju'],
    [/No reviews yet/gi, 'Vēl nav atsauksmju'],
    [/Write a review/gi, 'Uzrakstīt atsauksmi'],
  ];

  const ATTRS = ['aria-label', 'title', 'placeholder', 'value', 'data-text'];

  function translate(str) {
    if (!str || typeof str !== 'string') return str;
    if (!/write a review|no reviews|be the first/i.test(str)) return str;
    let out = str;
    for (let i = 0; i < REPLACEMENTS.length; i += 1) {
      out = out.replace(REPLACEMENTS[i][0], REPLACEMENTS[i][1]);
    }
    return out;
  }

  function translateNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    const next = translate(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  }

  function translateElement(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return;

    for (let i = 0; i < ATTRS.length; i += 1) {
      const name = ATTRS[i];
      if (!el.hasAttribute(name)) continue;
      const raw = el.getAttribute(name);
      const next = translate(raw);
      if (next !== raw) el.setAttribute(name, next);
    }

    // Direct text-only children (buttons/links often wrap a single text node).
    for (let child = el.firstChild; child; child = child.nextSibling) {
      translateNode(child);
    }
  }

  function translateTree(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      translateNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE) return;

    if (root.matches && root.matches(SCOPE)) {
      translateElement(root);
    }

    const nodes = root.querySelectorAll ? root.querySelectorAll(SCOPE) : [];
    for (let i = 0; i < nodes.length; i += 1) {
      translateElement(nodes[i]);
      const walker = document.createTreeWalker(nodes[i], NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();
      while (textNode) {
        translateNode(textNode);
        textNode = walker.nextNode();
      }
    }
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      translateTree(document.body);
    });
  }

  function start() {
    translateTree(document.body);

    const observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRS,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
